import { useState, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { Form, Input, Button } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { loginUser } from "./auth";
import { userProvider } from "../../contexts/UserContext";
import { domainProvider } from "../../contexts/DomainContext";

const LoginForm = () => {
  const { t } = useTranslation();
  const selectLanguage = i18next.language;
  const navigate = useNavigate();
  const { refetchUser } = useContext(userProvider);
  const { customdomain } = useContext(domainProvider);

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [contactLogin, setContactLogin] = useState(false);
  const [phoneInput, setPhoneInput] = useState("");

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const result = await loginUser(values, customdomain);
      setLoading(false);

      if (result.status_code === 200) {
        const {
          vendor_id,
          vendor_name,
          vendor_email,
          vendor_contact,
          profile_image,
        } = result.data;
        const token = result.accessToken;
        const refreshToken = result.refreshToken;

        const user = {
          vendor_id,
          vendor_name,
          vendor_email,
          vendor_contact,
          profile_image,
          token,
          refreshToken,
          storename: result.storeDetails.store_name,
        };

        localStorage.setItem("user", JSON.stringify(user));
        navigate("/vendor/main-flow");
        // refetchUser();
        setTimeout(() => {
          window.location.reload();
        }, 500);
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      setLoading(false);
      const error = err?.response?.data?.message || "Login failed";
      toast.error(error);
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      className="w-full py-5 flex flex-col"
    >
      <h2 className="text-center text-2xl md:text-3xl mb-4">
        {selectLanguage === "ar" ? "تسجيل دخول المتجر" : "Store Login"}
      </h2>

      <Form.Item
        label={
          <div className="flex justify-between items-center w-full">
            <span>{contactLogin ? t("l_phone") : t("l_email")}</span>
            <span
              className="text-xs cursor-pointer text-orange-500 ml-40"
              onClick={() => {
                setContactLogin(!contactLogin);
                setPhoneInput("");
                form.setFieldsValue({ username: "" });
              }}
            >
              {t("v_l_f1")} {contactLogin ? t("l_email") : t("l_phone")}?
            </span>
          </div>
        }
        name="username"
        rules={[
          {
            required: true,
            message: contactLogin
              ? t("contact_required")
              : t("form_email_required"),
          },
        ]}
      >
        {contactLogin ? (
          <Input
            addonBefore="+966"
            maxLength={9}
            value={phoneInput}
            onChange={(e) => {
              const onlyNums = e.target.value.replace(/[^0-9]/g, "");
              setPhoneInput(onlyNums);
              form.setFieldsValue({ username: onlyNums });
            }}
            placeholder="5XXXXXXXX"
            size="large"
          />
        ) : (
          <Input
            type="email"
            placeholder={t("l_phone_m")}
            size="large"
          />
        )}
      </Form.Item>


      <Form.Item
        label={t("l_p")}
        name="password"
        rules={[{ required: true, message: t("l_p_r") }]}
      >
        <Input.Password
          placeholder={t("l_p_p")}
          iconRender={(visible) =>
            visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
          }
          size="large"
        />
      </Form.Item>

      <Form.Item>
        <button
          type="primary"
          htmlType="submit"
          disabled={loading}
          className="w-full btn btn-primary rounded-md text-white mt-4"
        >
          {loading ? t("v_loading") : t("v_l_f")}
        </button>
      </Form.Item>

      <div className="flex justify-end">
        <Link to="/vendor/forget-pass" className="text-primary text-sm">
          {t("l_p_forget")}
        </Link>
      </div>

      <div className="flex flex-col w-full">
        <div className="divider">{t("l_p_haveAccount")}</div>
        <Link
          className="border border-px border-primary py-2 flex justify-center items-center text-primary hover:bg-primary hover:!text-white duration-300 transition-all"
          to="/vendor/register"
        >
          {t("l_p_create")}
        </Link>
      </div>
    </Form>
  );
};

export default LoginForm;
